import { useState, useEffect } from "react";
import JobContext from "./JobContext";
import { ADMIN_API_BASE_URL } from "../api/apiBaseUrl";

export default function JobProvider({ children }) {
    const jobsPerPage = 6;
    const BASE_URL = ADMIN_API_BASE_URL;

    const [jobListings, setJobListings] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const submitApplication = async (jobId, applicantData) => {
        try {
            const res = await fetch(`${BASE_URL}/careers/apply`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    jobId,
                    ...applicantData,
                }),
            });

            const json = await res.json();
            return json; // Send response back to component
        } catch (err) {
            console.error("Failed to submit application", err);
            throw err;
        }
    };
    // Fetch jobs from backend when currentPage changes
    useEffect(() => {
        const fetchJobs = async () => {
            setLoading(true);

            try {
                const res = await fetch(
                    `${BASE_URL}/careers/jobs?page=${currentPage}&limit=${jobsPerPage}`
                );
                console.log( "res::", res);
                const json = await res.json();
                console.log( "json", json);

                setJobListings(json.data || []);
                setTotalPages(json.pagination?.totalPages || 1);
            } catch (err) {
                console.error("Failed to fetch jobs", err);
            } finally {
                setLoading(false);
            }
        };

        fetchJobs();
    }, [currentPage]);

    // Pagination functions
    const goPrev = () => setCurrentPage((p) => Math.max(1, p - 1));
    const goNext = () => setCurrentPage((p) => Math.min(totalPages, p + 1));

    // Ellipsis pagination logic
    const getPaginationNumbers = () => {
        const pages = [];

        if (totalPages < 5) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, "...", totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(
                    1,
                    "...",
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    "...",
                    totalPages
                );
            }
        }

        return pages;
    };

    return (
        <JobContext.Provider
            value={{
                jobListings,
                loading,
                jobsPerPage,
                totalPages,
                currentPage,
                goPrev,
                goNext,
                setCurrentPage,
                getPaginationNumbers,
                submitApplication,
            }}
        >
            {children}
        </JobContext.Provider>
    );
}
